import React, { Component } from "react";
import DataTable from "react-data-table-component";
import history from "../login/history";
import AuthService from "../../../services/login/auth.service";
import AvisoGeneral from "../../generico/AvisoGeneral";

const paginationOptions = {
  rangeSeparatorText: "de",
  rowsPerPageText: "Filas por página",
  selectAllRowsItem: true,
  selectAllRowsItemText: "Todos",
  //noRowsPerPage:true
};

export default class Subsidios extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opcion: [],
      options: this.props.subsidios,
      tieneArchivosRechazados: false
    };
  }

  componentWillReceiveProps(newProps) {
    let archivoRechazado = false;

    if (newProps.subsidios !== this.props.options)
      archivoRechazado = newProps?.subsidios.find(el => +el.estadoID === 10);
      this.setState({
        options: newProps.subsidios,
        tieneArchivosRechazados: archivoRechazado ? true : false
      });
  }

  componentDidMount() {
    let usuario = AuthService.getCurrentUser();

    this.setState({
      nombreSocio: usuario.nombreCompleto,
      cedulaSocio: usuario.cedulaIdentidad,
    });
  }

  getColumnDetalle(tieneRechazados = false) {
    let columnas = [
      {
        name: "Número Solicitud",
        center: true,
        selector: row => row.nroSolicitud,
      },
      {
        name: "Cuenta Ahorro",
        center: true,
        selector: row => row.cuentaAhorro,
      },
      {
        name: "Tipo Subsidio",
        selector: row => row.tipoSubsidio,
        width: "180px",
      },
      {
        name: "Clase Subsidio",
        selector: row => row.claseSubsidio,
        width: "150px",
      },
      {
        name: "Fecha Hecho",
        selector: row => row.fechaHecho,
        center: true,
        width: "120px",
      },
      {
        name: "Fecha Presentación",
        selector: row => row.fechaPresentacion,
        center: true,
        minWidth: "120px",
      },
      {
        name: "Estado",
        selector: row => row.estado,
      },
    ];

    if (tieneRechazados) {
      columnas.push({
        minWidth: "200px",
        center: true,
        cell: (row) =>
          +row.estadoID === 10 && (
            <button
              className="btn btn-cu-primary btn-sm"
              param={row}
              onClick={() => {
                history.push({ pathname: "/modificarSubsidio", state: row });
                window.location.reload();
              }}
            >
              <i className="fas fa-info-circle" />
              <span> Actualizar Archivos</span>
            </button>
          ),
      });
    }

    return columnas;
  }

  render() {
    return (
      <>
      {this.state.tieneArchivosRechazados && <AvisoGeneral />}
        <DataTable
          noHeader={true}
          pagination={true}
          columns={this.getColumnDetalle(this.state.tieneArchivosRechazados)}
          data={this.state.options}
          paginationComponentOptions={paginationOptions}
          noDataComponent="no hay registros para mostrar"
          responsive={true}
          striped={true}
          pointerOnHover
        />
      </>
    );
  }
}
